import React from 'react';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import HeaderContainer from '@ui/features/Header/Header.container';
import ReportsContainer from '@ui/features/Reports/Reports-main.container';
import ReportsMenuContainer from '@ui/features/Reports-menu/Reports-menu.container';
import withPage from '@ui/HOCs/withPage';
import withSideBar from '@ui/HOCs/withSideBar';
import withSection from '@ui/HOCs/withSection';
import withSections from '@ui/HOCs/withSections';
import { lang } from '@lang/interfaces/lang';

interface IProps extends JSX.IntrinsicAttributes {
    lang: lang;
}

const SideBar = withSideBar(ReportsMenuContainer);
const Section = withSection(ReportsContainer);
const Sections = withSections(Section);

const Page: React.FC<IProps> = () => {
    return (
        <>
            <HeaderContainer />
            <Box className="main" component="main">
                <SideBar />
                <Sections />
            </Box>
        </>
    );
};

const WrappedPage = withPage(Page, 'main__wrap', 'reports');

const ReportsPage = observer(WrappedPage);

export default ReportsPage;
